import type WhiteSpaceStyles from './types';

const whiteSpace: WhiteSpaceStyles = {
  noWrap: {
    whiteSpace: 'nowrap',
  },
  preWrap: {
    whiteSpace: 'pre-wrap',
  },
  pre: {
    whiteSpace: 'pre',
  },
};

export default whiteSpace;
